import { Injectable } from '@angular/core';

import { UrlConstants, API_ENDPOINTS } from '@varsity/commons';
import { HttpHelperService, LoggingService, Confirmation, TokenService, PriceService, StripeCreateSessionResponse } from '@varsity/services';
import { Observable } from 'rxjs';

@Injectable()
export class StripeService {
    constructor(private httpHelperService: HttpHelperService,
        private loggingService: LoggingService,
        private tokenService: TokenService,
        private priceService: PriceService,
    ) {

    }

    createSession(confirmation: Confirmation, amount: number, dbName: string, location: string, customerId: number): Observable<StripeCreateSessionResponse> {
        this.loggingService.debug('generate stripe session');

        const url = UrlConstants.tokenBOUrl + API_ENDPOINTS.createSession;

        let promise = this.httpHelperService
            .post<StripeCreateSessionResponse>(url,
                confirmation,
                {
                    params: {
                        "X-Token": this.tokenService.getToken(),
                        "Amt": this.priceService.formatPrice(amount, 2, ""),
                        "DBName": dbName,
                        "Location": location,
                        "CustomerID": customerId
                    }
                });

        return promise;
    }
}



// WEBPACK FOOTER //
// ./src/services/stripe/stripe.service.ts